export const menuListAdmin = [
  {
    title: 'Relatórios',
    icon: 'paper',
    link: '/admin/relatorios',
    color: 'red'
  },
  {
    title: 'Lista de bolsistas',
    icon: 'list',
    link: '/admin/lista',
    color: 'blue'
  },
  {
    title: 'Bolsas expiradas',
    icon: 'cancel',
    link: '/admin/bolsas/expiradas',
    color: 'green'
  }
]
